import { useTranslation } from 'react-i18next';

/** Root-level ErrorBoundary fallback — full-app crash, only real recovery is a reload. */
export function RootErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="error-fallback" role="alert" data-testid="root-error-fallback">
      <h1 className="error-fallback__title">{t('error.title')}</h1>
      <p className="error-fallback__message">{t('error.message')}</p>
      <button className="error-fallback__button" onClick={() => window.location.reload()}>
        {t('error.reload')}
      </button>
    </div>
  );
}
